module.exports = __webpack_public_path__ + "img/IMAGE6.23e928d7.jpg";